import { render } from "./CustomerRanking.vue?vue&type=template&id=1e4c2c04&scoped=true&ts=true"
import script from "./CustomerRanking.vue?vue&type=script&lang=ts"
export * from "./CustomerRanking.vue?vue&type=script&lang=ts"

import "./CustomerRanking.vue?vue&type=style&index=0&id=1e4c2c04&lang=scss&scoped=true"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e4c2c04"]])

export default __exports__